import { FeedbackCard } from '../../components'

export const VerifyEmail: React.FC = () => {
  return (
    <FeedbackCard title="Te enviamos un mail para confirmar tu casilla" showLoginText={false} />
  )
}
